const store = {
  ads: new Map()
};

export default store;
